"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.replace");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.File = exports.Status = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Spinner = _interopRequireDefault(require("../Spinner"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Status = {
  GENERATING: 'draft',
  READY: 'final',
  FAILED: 'failed',
  TIMED_OUT: 'timeout'
};
exports.Status = Status;

var File = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(File, _React$PureComponent);

  var _super = _createSuper(File);

  function File() {
    _classCallCheck(this, File);

    return _super.apply(this, arguments);
  }

  _createClass(File, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          size = _this$props.size,
          dateUploaded = _this$props.dateUploaded,
          isAnalyticsEnabled = _this$props.isAnalyticsEnabled,
          onClick = _this$props.onClick,
          role = _this$props.role,
          status = _this$props.status;
      var type = this.props.type.replace(/^[.]/, ''); // Strip leading dots from extension if any

      var iconClass = "icon filetype-".concat(type);

      var icon = /*#__PURE__*/_react.default.createElement("span", {
        className: iconClass
      });

      if (status) {
        switch (status) {
          case Status.TIMED_OUT:
          case Status.FAILED:
            type = status;
            icon = /*#__PURE__*/_react.default.createElement("span", {
              className: "icon filetype-".concat(type)
            });
            break;

          case Status.GENERATING:
            type = 'processing';
            icon = /*#__PURE__*/_react.default.createElement(_Spinner.default, {
              active: true
            });
            break;
        }
      }

      var optionalProps = {};
      optionalProps.target = '_blank'; // if Analytics is enabled

      if (isAnalyticsEnabled) {
        optionalProps.onClick = onClick;
        optionalProps.role = role;
      }

      var fileData = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, icon, /*#__PURE__*/_react.default.createElement("span", {
        className: "link-item-title"
      }, title), /*#__PURE__*/_react.default.createElement("span", {
        className: "link-item-meta"
      }, /*#__PURE__*/_react.default.createElement("span", null, size, " "), /*#__PURE__*/_react.default.createElement("span", {
        className: "link-item-type"
      }, "[", type.toUpperCase(), "]"), dateUploaded && /*#__PURE__*/_react.default.createElement("span", null, " | Uploaded on ".concat(dateUploaded))));

      if (!status) {
        return /*#__PURE__*/_react.default.createElement("a", _extends({
          href: this.props.href,
          className: "link-item has-icon"
        }, optionalProps), fileData);
      } else {
        switch (status) {
          case Status.GENERATING:
            return /*#__PURE__*/_react.default.createElement("div", _extends({
              className: "link-item is-generating has-icon"
            }, optionalProps), fileData);

          case Status.READY:
            return /*#__PURE__*/_react.default.createElement("a", _extends({
              href: this.props.href,
              className: "link-item has-icon"
            }, optionalProps), fileData);

          case Status.TIMED_OUT:
          case Status.FAILED:
            return /*#__PURE__*/_react.default.createElement("div", _extends({
              className: "link-item is-error has-icon"
            }, optionalProps), fileData);
        }
      }
    }
  }]);

  return File;
}(_react.default.PureComponent);

exports.File = File;
File.defaultProps = {
  status: null,
  size: null,
  title: null,
  dateUploaded: null,
  isAnalyticsEnabled: false,
  onClick: function onClick() {},
  role: 'button'
};
File.propTypes = {
  /**
   * File location
   */
  href: _propTypes.default.string.isRequired,

  /**
   * The file extension
   * eg gif or image
   */
  type: _propTypes.default.string.isRequired,

  /**
   * File size
   */
  size: _propTypes.default.string,

  /**
   * File title
   */
  title: _propTypes.default.string,

  /**
   * Date file was uploaded
   */
  dateUploaded: _propTypes.default.string,

  /**
   * Analytics releated.
   */
  isAnalyticsEnabled: _propTypes.default.bool,

  /**
   * Current readiness
   */
  status: _propTypes.default.string,
  onClick: _propTypes.default.func,
  role: _propTypes.default.string
};
//# sourceMappingURL=File.js.map